import React, {
  useCallback,
  useContext,
  useState,
  useEffect,
} from 'react';
import CrmView from 'screens/Admin/Crm/components/View';
import useFetchTableData from 'hooks/useFetchTableData';
import AdminCrmService from 'services/api/AdminCrm';
import ModulesService from 'services/api/Modules';
import AdminContainer from 'components/Admin/AdminContainer';
import handlePromise from 'utils/Promise';
import { LoadingContext } from 'context/Loading';
import { ModalErrorContext } from 'context/ModalError';
import moment from 'moment';

function CrmScreen() {
  const { toggleLoading } = useContext( LoadingContext );
  const { openErrorModal } = useContext( ModalErrorContext );
  const [lastSyncStatus, setLastSyncStatus] = useState( '' );

  const { fetchData, data, dataLoading } = useFetchTableData( {
    promise: AdminCrmService.getCrmLogs,
    deps: [],
  } );

  const updateCrm = useCallback( async ( ) => {
    toggleLoading( true );

    const [responseError, response] = await handlePromise(
      ModulesService.updateModuleRefresh( ),
    );

    if ( !response.ok ) {
      openErrorModal( responseError.toString() );
    }

    setTimeout( () => {
      toggleLoading( false );
    }, 800 );
  }, [] );

  useEffect( ( ) => {
    handlePromise(
      ModulesService.getLastCRMSyncStatus( ),
    ).then( ( [, response, responseData] ) => {
      if ( response.ok ) {
        setLastSyncStatus( `Última actualización de datos del CRM con estado: ${responseData.status} el ${moment( responseData.updatedAt ).format( 'DD-MM-YYYY HH:mm:ss' )}` );
      } else {
        setLastSyncStatus( '' );
      }
    } );
  }, [] );

  return (
    <AdminContainer>
      <CrmView
        data={data}
        fetchData={fetchData}
        isLoading={dataLoading}
        updateCrm={updateCrm}
        lastSyncMessage={lastSyncStatus}
      />
    </AdminContainer>
  );
}

export default CrmScreen;
